import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Select, Input, Table, notification, message } from "antd";

import { NavigationPath } from "../../helpers/constants";
import ActionButtons from "../ActionButtons/ActionButtons";

const { Search } = Input;

const Korisnici = ({ state, actions }) => {
  const { users, suppliers } = state;

  useEffect(() => {
    setLoading(true);
    actions.getUsers();
    actions.getSuppliers();
    setLoading(false);
  }, []);

  const getSupplierName = (supplierId) => {
    const result = suppliers?.find(({ key }) => supplierId === key);
    return result?.kompanija;
  };

  const supplierSelectOptions = suppliers?.map((supplier) => ({
    value: supplier.kompanija,
    label: supplier.kompanija,
  }));

  const [searchUser, setSearchUser] = useState("");
  const [searchDobavljac, setSearchDobavljac] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, msg) => {
    api[type]({
      message: msg,
      style: {
        width: 400,
      },
    });
  };

  const columns = [
    {
      title: "Ime i prezime",
      dataIndex: "ime",
      width: 160,
      filteredValue: [searchUser],
      onFilter: (value, record) => {
        return record.ime.toLowerCase().includes(value.toLowerCase());
      },
      render: (text) => <a className="text-light-blue">{text}</a>,
    },
    {
      title: "Dobavljač",
      dataIndex: "dobavljac",
      width: 220,
      filteredValue: [searchDobavljac],
      onFilter: (value, record) => {
        return record?.dobavljac?.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      width: 200,
    },
    {
      title: "Rola",
      dataIndex: "rola",
      width: 160,
      sorter: (a, b) => a.rola.localeCompare(b.rola),
    },
    {
      title: "Datum",
      dataIndex: "datum",
      width: 185,
      sorter: (a, b) => new Date(a.datum) - new Date(b.datum),
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedUser(selectedRows);
    },
  };

  const onSearch = (value) => {
    setSearchUser(value);
  };

  const onChange = (pagination, sorter) => {};

  const navigateToRegisterUser = () => {
    navigate(NavigationPath.REGISTER_USER);
  };

  const navigateToEdit = () => {
    if (selectedUser?.length === 1) {
      navigate(`/user/${selectedUser[0].key}`);
    } else {
      openNotificationWithIcon("warning", "Select one user to edit");
    }
  };

  const handleDeleteUser = () => {
    if (selectedUser) {
      const userIds = selectedUser.map((user) => user.key);
      actions.deleteUser(userIds);
      setSelectedUser(null);
    }
  };

  return (
    <div className="px-8 py-4">
      {contextHolder}
      <Flex justify="space-between" className="mb-4">
        <ActionButtons
          navigateToAdd={navigateToRegisterUser}
          navigateToEdit={navigateToEdit}
          handleDelete={handleDeleteUser}
          selectedUser={selectedUser}
        />

        <Flex>
          <Select
            defaultValue="Dobavljač"
            bordered={false}
            options={supplierSelectOptions}
            onChange={(e) => setSearchDobavljac(e)}
            className="max-w-[210px]"
          />
          <Search
            className="bg-light-blue rounded-l-md rounded-r-sm w-80"
            placeholder="Traži po imenu / prezimenu korisnika"
            onSearch={onSearch}
            enterButton
          />
        </Flex>
      </Flex>
      <Table
        columns={columns}
        loading={loading}
        dataSource={users?.map((user) => ({
          ...user,
          dobavljac: getSupplierName(user.dobavljac),
        }))}
        rowSelection={{
          ...rowSelection,
        }}
        onChange={onChange}
      />
    </div>
  );
};

export default Korisnici;
